export default {
    methods: {
        rgbaToCss({ r, g, b, a }) {
            // if (!r || !g || !b || !a)
            //     return null

            return `rgba(${r},${g},${b},${a})`;
        }
    }
};
